import { useSearchParams } from "react-router-dom";
import { useQuery} from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get } from "@utils/axios_api";

const fetchGridList = async (params) => {
  const response = await get("/gridList", { params });
  return response;
};

export function useGridList() {
  const [searchParams, setSearchParams] = useSearchParams();

  const methods = useForm({
    defaultValues: {
      searchCnd: "",
      searchWrd: "",
      createStDate: "",
      createEndDate: "",
    },
    shouldFocusError: false, // Focus 방지(포커스 구현시 React ref 구현 해야함)
  });

  const { watch, setValue } = methods;
  
  const searchCnd = searchParams.get("searchCnd") || "";
  const searchWrd = searchParams.get("searchWrd") || "";
  const createStDate = searchParams.get("createStDate") || "";
  const createEndDate = searchParams.get("createEndDate") || "";
  const sortField = searchParams.get("sortField") || "";
  const sortOrder = searchParams.get("sortOrder") || "";

  const queryParam = {
    searchCnd,
    searchWrd,
    createStDate,
    createEndDate,
    sortField,
    sortOrder,
  };

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["selectBoardList", queryParam],
    queryFn: () => fetchGridList(queryParam),
    // enabled: false, // 더미 데이터 사용중 false
    keepPreviousData: true,
    staleTime: 600000,
  });


  // 이벤트 핸들러
  const onSubmit = (values) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("searchCnd", values.searchCnd || "");
    newParams.set("searchWrd", values.searchWrd || "");
    newParams.set("createStDate", values.createStDate ? values.createStDate + " 00:00:00" : "");
    newParams.set("createEndDate", values.createEndDate ? values.createEndDate + " 23:59:59" : "");
    setSearchParams(newParams);
  };


  return {
    methods,
    data,
    isLoading,
    isError,
    error,
    watch,
    setValue,
    onSubmit,
    refetch,
  };
}
